module.exports = __webpack_public_path__ + "img/signed.b68c0191.png";